<ng-container *ngIf="aiListIngredientMenuViewModel$ | async as viewModel">
  <ion-header
    class="ion-no-border ion-header-menu"
    [class.desktop]="platformService.platformType === platformRef.desktop"
  >
    <ion-toolbar class="toolbar-background">
      <ion-buttons slot="end">
        <ion-button
          (click)="onCancel(viewModel)"
          class="close-button"
          data-cy="close-sidebar-button"
        >
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <h1 *ngIf="!showFilterView" class="title">
      {{ 'i18n.lists.aiListEditMenu.title' | translate }}
    </h1>
    <div class="filter-title-container" *ngIf="showFilterView">
      <ion-icon
        class="back-icon"
        src="assets/icon/chevron-left.svg"
        (click)="resetFilterView()"
      ></ion-icon>
      <h1 class="filter-title">{{ 'i18n.lists.filter' | translate }}</h1>
    </div>
  </ion-header>

  <ion-content
    [class.desktop]="platformService.platformType === platformRef.desktop"
  >
    <ng-container *ngIf="!showFilterView">
      <!-- Always show sub-header with search -->
      <div
        class="sub-header"
        [class.mobile]="platformService.platformType === platformRef.mobile"
      >
        <h2 class="sub-title">
          {{ 'i18n.lists.aiListEditMenu.subTitle' | translate }}
        </h2>
        <div class="search-container">
          <ion-searchbar
            class="search"
            mode="md"
            [placeholder]="
              'i18n.lists.aiListEditMenu.searchPlaceholder' | translate
            "
            [(ngModel)]="searchQuery"
            (ionInput)="onSearchInput()"
            data-cy="ai-list-ingredient-menu-searchbar"
          >
          </ion-searchbar>

          <app-sort-and-filter-button
            [sortAndFilterText]="'i18n.lists.filter'"
            [sortAndFilterCount]="selectedFilterCount"
            [platformType]="platformService.platformType"
            [showClearAll]="false"
            (openSortAndFilterListModalEmitter)="onFilter()"
            data-cy="ai-list-ingredient-menu-filter-button"
          ></app-sort-and-filter-button>
        </div>
      </div>
      <div class="divider"></div>

      <!-- Always show current pick -->
      <div class="content-container">
        <h2 class="sub-title">
          {{ 'i18n.lists.aiListEditMenu.currentPick' | translate }}
        </h2>
        <app-ai-list-ingredient-menu-product-card
          [product]="
            !viewModel.selectedSearchResult
              ? viewModel.initialAIListProductCardViewModel?.product
              : viewModel.selectedSearchResult
          "
          [isOnline]="panAppState.online$ | async"
          [hideRadioButton]="true"
        ></app-ai-list-ingredient-menu-product-card>
      </div>
      <div class="divider"></div>

      <!-- Choose from section with conditional loading state -->
      <div class="content-container">
        <!-- Loading state for search results -->
        <ng-container *ngIf="viewModel.loading">
          <div class="loading-container">
            <div class="loading-text">
              {{
                'i18n.lists.aiListEditMenu.loadingSpinnerMessage' | translate
              }}
            </div>
            <ion-spinner name="circles"></ion-spinner>
          </div>
        </ng-container>

        <!-- Search results when loaded -->
        <ng-container *ngIf="viewModel.loaded">
          <h2
            *ngIf="isBestSellingSearch && viewModel.searchResults?.length > 0"
            class="sub-title"
          >
            {{
              'i18n.lists.aiListEditMenu.chooseFrom'
                | translate
                  : {
                      productName:
                        viewModel.initialAIListProductCardViewModel
                          ?.ingredientDisplayName ?? '' | lowercase,
                    }
            }}
          </h2>

          <!-- No results found state -->
          <ng-container *ngIf="viewModel.searchResults?.length === 0">
            <div class="no-products-container">
              <div class="no-products-text">
                {{ 'i18n.lists.aiListEditMenu.noProductsFound' | translate }}
              </div>
            </div>
          </ng-container>

          <!-- Search results when available -->
          <ng-container *ngIf="viewModel.searchResults?.length > 0">
            <ng-container *ngFor="let searchResult of viewModel.searchResults">
              <app-ai-list-ingredient-menu-product-card
                [product]="searchResult"
                [selected]="
                  !viewModel.selectedSearchResult
                    ? viewModel.initialAIListProductCardViewModel?.product
                        ?.productNumber === searchResult?.productNumber
                    : viewModel.selectedSearchResult?.productNumber ===
                      searchResult?.productNumber
                "
                [isOnline]="panAppState.online$ | async"
                (productClicked)="onProductClicked($event)"
              ></app-ai-list-ingredient-menu-product-card>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="showFilterView">
      <ion-item
        *ngFor="let option of filterOptions"
        [class.selected]="option.selected"
        (click)="toggleFilterOption(option)"
        attr.data-cy="filter-option-{{ option.id }}"
        lines="none"
      >
        <ion-checkbox [checked]="option.selected" labelPlacement="start">{{
          option.label | translate
        }}</ion-checkbox>
      </ion-item>
    </ng-container>
  </ion-content>

  <ion-footer
    class="ion-footer-menu"
    mode="md"
    [class.ion-footer-modal-desktop]="
      platformService.platformType !== platformRef.mobile
    "
  >
    <ion-button
      data-cy="cancel-ai-list-ingredient-menu-button"
      [ngClass]="
        platformService.platformType !== platformRef.mobile
          ? 'usf-outline-green-dsktp-tblt-modal-button'
          : 'usf-outline-green-mobile-modal-button'
      "
      (click)="onCancel(viewModel)"
    >
      {{ 'i18n.common.cancel' | translate }}
    </ion-button>
    <ion-button
      data-cy="save-ai-list-ingredient-menu-button"
      [ngClass]="
        platformService.platformType !== platformRef.mobile
          ? (!viewModel.selectedSearchResult && !showFilterView) ||
            (showFilterView && !shouldEnableSaveInFilterView())
            ? 'usf-fill-disabled-dsktp-tblt-modal-button'
            : 'usf-fill-green-dsktp-tblt-modal-button'
          : (!viewModel.selectedSearchResult && !showFilterView) ||
              (showFilterView && !shouldEnableSaveInFilterView())
            ? 'usf-fill-disabled-mobile-modal-button'
            : 'usf-fill-green-mobile-modal-button'
      "
      (click)="onSave(viewModel)"
    >
      {{ 'i18n.common.save' | translate }}
    </ion-button>
  </ion-footer>
</ng-container>
